import { useStore } from '@nanostores/react';
import { map } from 'nanostores';

/**
 * Keyed per patient: a clinician's other copies finish seeding while a chart
 * is open, and none of those may remount it.
 */
export const $demoResetEpochs = map<Record<string, number>>({});

export function bumpDemoResetEpoch(patientUserId: string): void {
  $demoResetEpochs.setKey(patientUserId, ($demoResetEpochs.get()[patientUserId] ?? 0) + 1);
}

export function useDemoResetEpoch(patientUserId: string): number {
  const epochs = useStore($demoResetEpochs, { keys: [patientUserId] });
  return epochs[patientUserId] ?? 0;
}
